import { render, staticRenderFns } from "./CoreData.vue?vue&type=template&id=3fd25857&scoped=true"
import script from "./CoreData.vue?vue&type=script&lang=js"
export * from "./CoreData.vue?vue&type=script&lang=js"
import style0 from "./CoreData.vue?vue&type=style&index=0&id=3fd25857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd25857",
  null
  
)

export default component.exports